module.exports = __webpack_public_path__ + "img/green_019.0fa6931d.png";